const statusMap = {
  UP: 'success',
  ACTIVE: 'success',
  SUCCESS: 'success',
  DEGRADED: 'warning',
  SKIPPED: 'warning',
  INACTIVE: 'neutral',
  DOWN: 'danger',
  ERROR: 'danger',
};

export default function StatusBadge({ status }) {
  const variant = statusMap[status?.toUpperCase()] || 'neutral';
  return <span className={`badge badge-${variant}`}>{status}</span>;
}
